import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getUserPermissions } from "./permissions";

const ProtectedRoute = ({ element: Element, isAuthenticated, redirectTo, requiredPermission, additionalCheck, ...props }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = sessionStorage.getItem('access_token');
    
    console.log('🛡️ ProtectedRoute Check:', {
      path: window.location.pathname,
      hasAccessToken: !!accessToken,
      isAuthenticated,
      redirectTo,
      requiredPermission
    });
    
    // If no access token, redirect to login
    if (!accessToken) {
      console.log('❌ ProtectedRoute: No access token, redirecting to:', redirectTo);
      navigate(redirectTo);
      return;
    }

    // If not authenticated, redirect to login
    if (!isAuthenticated) {
      console.log('❌ ProtectedRoute: Not authenticated, redirecting to:', redirectTo);
      navigate(redirectTo);
      return;
    }

    // If a requiredPermission is provided, verify it
    if (requiredPermission) {
      const userPermissions = getUserPermissions();
      if (!userPermissions.includes(requiredPermission)) {
        console.log('❌ ProtectedRoute: Missing permission, redirecting to 403');
        navigate("/403");
        return;
      }
    }

    // If an additionalCheck function is provided, verify it
    if (additionalCheck && typeof additionalCheck === 'function') {
      const hasAccess = additionalCheck();
      if (!hasAccess) {
        console.log('❌ ProtectedRoute: Additional check failed, redirecting to:', redirectTo);
        navigate(redirectTo);
        return;
      }
    }
    
    console.log('✅ ProtectedRoute: Access granted');
  }, [isAuthenticated, navigate, redirectTo, requiredPermission, additionalCheck]);

  return isAuthenticated ? <Element {...props} /> : null;
};

export default ProtectedRoute;